module.exports = __webpack_public_path__ + "static/media/ViewSearch.b3573eb5.svg";